module.exports = __webpack_public_path__ + "img/tutorial_classes_04.dedb54bf.gif";